import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=a872d4d8&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a872d4d8')) {
      api.createRecord('a872d4d8', component.options)
    } else {
      api.reload('a872d4d8', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=a872d4d8&", function () {
      api.rerender('a872d4d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20Z1ziZpc0DrW/JS/comp/pricelist.vue"
export default component.exports